import CheckBox from '@components/common/checkbox/CheckBox';
import * as SC from '@components/common/checkbox/CheckBox.style';
import styled from '@emotion/styled';
import React from 'react';

type TargetCheckBoxProps = {
  className?: string;
  children?: React.ReactNode;
  targetValue: string;
  label?: string;
  checked: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  divRef?: React.RefObject<HTMLDivElement>;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const TargetCheckBox = ({
  className,
  targetValue,
  children,
  label,
  checked,
  disabled,
  readOnly,
  divRef,
  onChange,
}: TargetCheckBoxProps) => {
  return (
    <CheckBox targetValue={targetValue} checked={checked} disabled={disabled} onChange={onChange} divRef={divRef}>
      <SC.Flex className={`common-checkbox-item ${className}`}>
        <CheckBox.Indicator readOnly={readOnly}>{!readOnly && <CheckBox.Icon />}</CheckBox.Indicator>
        <Label disabled={disabled} readOnly={readOnly}>
          {label && <SC.LabelText>{label}</SC.LabelText>}
          {children && children}
        </Label>
      </SC.Flex>
    </CheckBox>
  );
};

export default TargetCheckBox;

const Label = styled(CheckBox.Label)<{
  disabled?: boolean;
  readOnly?: boolean;
}>`
  display: flex;
  align-items: center;
  width: fit-content;
  height: 100%;
  width: 100%;
  cursor: ${({ disabled, readOnly }) => (disabled || readOnly ? 'default' : 'pointer')};
`;
